﻿import { localeInfo } from '../locale';

interface IFormatter {
    format(date: Date): string
}

class StaticFormatter implements IFormatter {
    constructor(private pattern: string) {
    }
    format(date: Date): string {
        return this.pattern;
    }
}

class YearFormatter implements IFormatter {
    constructor(private patternLength: number) {
        if (this.patternLength !== 2 && this.patternLength !== 4) {
            throw new Error('Year formatter only support yy or yyyy');
        }
    }
    format(date: Date): string {
        const fullYear = String(date.getFullYear());
        if (this.patternLength === 4) {
            return fullYear;
        } else {
            return fullYear.substring(2, 4);
        }
    }
}

class MonthFormatter implements IFormatter {
    constructor(private patternLength: number) {
        if (this.patternLength > 4) {
            throw new Error('Month formatter only support M,MM,MMM,MMMM');
        }
    }
    format(date: Date): string {
        const monthIdx = date.getMonth();
        const monthValue: number = date.getMonth() + 1;
        if (this.patternLength === 1) {
            return String(monthValue);
        } else if (this.patternLength === 2) {
            if (monthValue >= 10) {
                return String(monthValue);
            } else {
                return String(`0${monthValue}`);
            }
        } else if (this.patternLength === 3) {
            const shortNames: string[] = localeInfo.calendar!.shortMonthNames!;
            return shortNames[monthIdx];
        } else if (this.patternLength === 4) {
            const fullNames: string[] = localeInfo.calendar!.fullMonthNames!;
            return fullNames[monthIdx];
        }
        return '';
    }
}


class DayFormatter implements IFormatter {
    constructor(private patternLength: number) {
        if (this.patternLength > 2) {
            throw new Error('Day formatter only support d,dd');
        }
    }
    format(date: Date): string {
        const dateValue = date.getDate();
        if (this.patternLength === 1) {
            return String(dateValue);
        } else if (this.patternLength === 2) {
            if (dateValue >= 10) {
                return String(dateValue);
            } else {
                return String(`0${dateValue}`);
            }
        } 
        return '';
    }
}

export class DateFormatter {
    formatters: IFormatter[] = [];

    addFormatter(pattern: string):void {
        if (pattern.indexOf('y') >= 0) {
            const fmt = new YearFormatter(pattern.length);
            this.formatters.push(fmt);
        }
        else if (pattern.indexOf('M') >= 0) {
            const fmt = new MonthFormatter(pattern.length);
            this.formatters.push(fmt);
        }
        else if (pattern.indexOf('d') >= 0 ) {
            const fmt = new DayFormatter(pattern.length);
            this.formatters.push(fmt);
        } else {
            const fmt = new StaticFormatter(pattern);
            this.formatters.push(fmt);
        }
    }

    format(input: Date): string {
        let result='';
        for (let i = 0; i < this.formatters.length; i++) {
            result+= this.formatters[i].format(input);
        }
        return result;
    }

}

export function convertToDateFormatter(format: string): DateFormatter {
    const formatter: DateFormatter = new DateFormatter();
    let currentPattern = '';
    for (let i = 0; i < format.length; i++) {
        if (i === 0) {
            currentPattern = format[i];
        } else {
            if (format[i] === format[i - 1]) {
                currentPattern += format[i];
            } else {
                //add extract and start a new pattern
                formatter.addFormatter(currentPattern);

                currentPattern = format[i];
            }
        }

        if (i === format.length - 1) {
            //the last pattern
            formatter.addFormatter(currentPattern);
        }
    }

    return formatter;
}